export { default, type ModalProps, type ModalWidth } from './Modal';
